import styled from "styled-components";
import {styledByDevice} from "../../../../../../themes/architecture/styled-by-device";
import {ACTIVE} from "../../../../../../themes/css-global-classes";

const DefaultBox = styled.div`
  margin-top: 1em;
  color: ${props => props.theme.components.newLiveCasino.colors.filterButtonLabel};
  font-size: 1.2em;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: color 0.25s ease;

  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  
  &.${ACTIVE} {
      color: ${props => props.theme.colors.buttonLight};
  }
`;

const PCBox = DefaultBox;

const MobileBox = styled(DefaultBox)`
  line-height: 1;
`;

export const LiveCasinoFilterButtonLabelDefaultBox = styledByDevice(PCBox,MobileBox);